import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { NestedComponentRenderer } from '../componentRenderer/NestedComponentRenderer';
import { Spacer } from '../spacer';

// Interface

export interface TwoColumnProps {
  centered?: boolean;
  columnOneComponents?: any; // TODO - componentstype
  columnTwoComponents?: any; // TODO - componentstype
}

export interface StyledTwoColumnProps {
  centered?: boolean;
}

// Styles

export const StyledTwoColumn = styled.div<StyledTwoColumnProps>`
  ${({ theme: { space, media, maxMedia }, centered }) => css`
    display: flex;
    gap: ${space.small};

    @media (max-width: ${maxMedia.large}) {
      flex-direction: column;
    }

    @media (min-width: ${media.medium}) {
      gap: ${space.xLarge};
    }

    @media (min-width: ${media.large}) {
      > * {
        flex-basis: 50%;
        max-width: 50%;
      }

      ${centered &&
      css`
        align-items: center;
      `};
    }
  `};
`;

export const StyledColumn = styled(Spacer)`
  ${({ theme: { space, colors, media } }) => css``};
`;

// JSX

export const TwoColumn: FC<TwoColumnProps> = ({
  centered,
  columnOneComponents,
  columnTwoComponents,
}) => (
  <StyledTwoColumn centered={centered}>
    <StyledColumn>
      <NestedComponentRenderer components={columnOneComponents} />
    </StyledColumn>
    <StyledColumn>
      <NestedComponentRenderer components={columnTwoComponents} />
    </StyledColumn>
  </StyledTwoColumn>
);

export default TwoColumn;
